(function( $ ) {
	$.fn.vgSwipeContent = function(options) {
		options = $.extend({
			height: 500,
			btn: {
				show: 'Показать',
				hide: 'Свернуть'
			}
		}, arguments[0] || {});

		return this.each(function () {
			let $section = $(this),
				height_section = $section.height();

			options.height = parseInt($section.attr('data-height')) || options.height;
			options.btn.show = parseInt($section.attr('data-btn-show')) || options.btn.show;
			options.btn.hide = parseInt($section.attr('data-btn-hide')) || options.btn.hide;

			if (height_section > options.height) {
				$section.css('height', options.height);
				$section.addClass('vg-swipe-content--hidden');

				$section.after('<div class="vg-swipe-content--btn"><a href="#" data-toggle="swipe-content">' + options.btn.show +'</a></div>');

				$('[data-toggle="swipe-content"]').click(function () {
					if ($section.hasClass('vg-swipe-content--hidden')) {
						$section.css('height', 'auto');
						$section.removeClass('vg-swipe-content--hidden');
						$(this).text(options.btn.hide);
					} else {
						$section.addClass('vg-swipe-content--hidden');
						$section.css('height', options.height);
						$(this).text(options.btn.show);
					}

					return false;
				});
			}
		});
	};
})(jQuery);

(function(document, $) {
	"use strict";

	$(document).ready(function () {
		$('[data-swipe-content]').vgSwipeContent();
	});

})(document, jQuery);


